/**
 * Academic titles that have a customary short form, and the form itself.
 *
 * <p>Doubles as the suggestion list on the teacher form, so the titles a manager is offered are
 * exactly the ones the schedule knows how to abbreviate. Kept as one map rather than two lists
 * because they drifted apart before: `професор` was stored as `проф`, `проф.` and `Професор`,
 * and only one of those abbreviated.
 *
 * <p>The column stays free text — the field suggests rather than restricts, so a title nobody
 * anticipated is still possible.
 */
export const TEACHER_POSITION_SHORT_FORMS = new Map([
    ['доцент', 'доц.'],
    ['асистент', 'ac.'],
    ['професор', 'проф.'],
]);

export const teacherPositionOptions = [...TEACHER_POSITION_SHORT_FORMS.keys()];
